import { configuration as countryConfiguration } from '../../countries/france/configuration';
import { adSlots } from './adSlotsConfig';
export const brandConfig = {
    brand: 'selogerneuf',
    headerBiddingScriptUrl: 'https://boot.pbstck.com/v1/adm/b335951b-9815-4fb4-8a92-78a19a159d17',
    gptScriptUrl: 'https://securepubads.g.doubleclick.net/tag/js/gpt.js',
    adSense: {},
    adSlots,
    googleTagManager: {
        function: `(function(w,d,s,l,i){
      w[l]=w[l]||[];
      w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
      var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),
          dl=l!='dataLayer' ? '&l='+l : '';
      j.async=true;
      j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
      f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-PVVJVR5');`,
    },
    ...countryConfiguration,
};
